import { UseStore } from 'zustand';
import { createUseExpectedPathChartStore } from '@quantfoliorepo/ui-components';

export const useExpectedPathChartStore: UseStore<any> =
  createUseExpectedPathChartStore();
